export default __webpack_public_path__ + "static/media/hp-plans-plan1.235b74d2.svg";